import { WorkspaceEmailAliasKind } from "@common/constants/domains/receipts/constants";
import { formatWorkspaceEmailAliasAddress } from "@common/helpers/workspace-email-alias";
import { WorkspaceEmailAlias } from "@common/schemas/workspace-email-alias.schema";

export interface EntityForwardingAlias {
    id: string;
    label: string;
    email: string;
}

interface EntityAddresses {
    receipts: string;
    bills: string;
    invoices: string;
}

const KIND_LABEL: Record<WorkspaceEmailAliasKind, string> = {
    receipts: "Receipts",
    bills: "Bills",
    invoices: "Invoices",
};

export function buildEntityForwardingAliases({
    addresses,
    aliases,
    entityUuid,
    kind,
}: {
    addresses: EntityAddresses | null;
    aliases: WorkspaceEmailAlias[];
    entityUuid: string;
    kind: WorkspaceEmailAliasKind;
}): EntityForwardingAlias[] {
    const rows: EntityForwardingAlias[] = [];
    const seen = new Set<string>();

    const add = (row: EntityForwardingAlias) => {
        if (seen.has(row.email)) {
            return;
        }
        seen.add(row.email);
        rows.push(row);
    };

    if (addresses) {
        add({
            id: kind,
            label: KIND_LABEL[kind],
            email: addresses[kind],
        });
    }

    for (const alias of aliases) {
        if (alias.entityUuid !== entityUuid || alias.kind !== kind) {
            continue;
        }
        add({
            id: `${alias.kind}:${alias.emailLocalPart}`,
            label: KIND_LABEL[alias.kind],
            email: formatWorkspaceEmailAliasAddress({
                emailLocalPart: alias.emailLocalPart,
                kind: alias.kind,
            }),
        });
    }

    return rows;
}
